import { call, put } from 'redux-saga/effects';
import { message } from 'antd';
import { setCrudRoute } from '../redux/crud/crudState';
import { showLoading, hideLoading } from '../redux/layout/layoutState';

export const LOADING_MSG = 'Loading...';
export const SAVING_MSG = 'Saving record';
export const UPDATING_MSG = 'Updating record';
export const DELETING_MSG = 'Deleting record';

export function* doCrudCall(apiCall, successAction, failAction, successMessage='', redirectData=null, loadingMessage='') 
{
	try {
		if(loadingMessage !== ''){
			yield put(showLoading(loadingMessage));
		}
    	const response = yield call(apiCall);
    	// console.log("DO CRUD CALL RESPONSE:", response);
		const { data, errorMessage, info_message } = response;
    	if(!errorMessage){
			yield put(successAction(data));
	    	if(info_message){
				message.success(info_message);
			}else if (successMessage) {
	      		message.success(successMessage);
	    	}
	    
	    	yield put(setCrudRoute(redirectData));
	    	
		} else {
			if (errorMessage?.email) {
				message.error(errorMessage.email);
			} else if (errorMessage !== null && typeof errorMessage !== 'object') {
				message.error(errorMessage);
			}

			yield put(failAction(errorMessage));
		}
    	
		yield put(hideLoading());
    	
  	} catch (error) {
		message.error(`Failed to perform operation: ${error}`);
    	console.error(`Failed to perform operation:`, error);
    	yield put(failAction(error.toString()));
    	yield put(hideLoading());
  	}
}

export function createRecordSuccess(modelName) 
{
	return `${modelName} record has been created.`;
}

export function updateRecordSuccess(modelName) 
{
	return `${modelName} record has been updated.`;
}

export function deleteRecordSuccess(modelName) 
{
	return `${modelName} record has been deleted.`;
}

export function requiredField() 
{
    return {
        required: true,
        message: 'This field is required',
      }
}

export function emailField() 
{
    return {
        type: 'email',
        message: 'Invalid Email',
      }
}

export function checkCRUDAccess(moduleRights, moduleId, actions, user, returnObject = false){
	if(user?.user_level === 1){
		return true;
	}
	
	if (moduleId === 0) {
		const actionList = Array.isArray(actions) ? actions : [actions];
		return returnObject
		? Object.fromEntries(actionList.map(action => [action, true]))
		: true;
	}

	const validActions = ["view", "add", "edit", "delete", "extract"];
	const actionList = Array.isArray(actions) ? actions : [actions];

	for (const action of actionList) {
		if (!validActions.includes(action)) {
			console.warn(`Invalid action: ${action}`);
			return returnObject
				? Object.fromEntries(actionList.map(a => [a, false]))
				: false;
		}
	}

	const module = moduleRights?.find(m => m.mri_module_id === moduleId);
	if (!module) {
		return returnObject
			? Object.fromEntries(actionList.map(action => [action, false]))
			: false;
	}

	const results = Object.fromEntries(
		actionList.map(action => [action, (module.access_rights?.[`ari_can_${action}`] ?? 0) > 0])
	);

	return returnObject ? results : Object.values(results).every(Boolean);
}